import type { ReactNode } from "react";

export function PageHeader({
  title,
  count,
  actions,
}: {
  title: string;
  count?: number | undefined;
  actions?: ReactNode;
}) {
  return (
    <header className="page-head">
      <h1>
        {title}
        {count !== undefined && <span className="page-head__count">{count}</span>}
      </h1>
      {actions && <div className="page-head__actions">{actions}</div>}
    </header>
  );
}

export function Loading() {
  return <p className="muted">Loading…</p>;
}

export function ErrorNote({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="note note--error">
      <strong>Something went wrong.</strong> {message}
    </div>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>;
}

export function StatusPill({ status }: { status: string }) {
  return (
    <span className={`pill pill--${status.toLowerCase()}`}>
      {status.replace(/_/g, " ").toLowerCase()}
    </span>
  );
}

export function formatDate(iso: string | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
